























import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import {
  CreatorService,
  CreatorServiceCategory,
  InputCreatorServiceCreate,
  InputCreatorServiceSearch,
  InputCreatorServiceUpdate,
} from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import useFiles from "@/hooks/useFiles";
import CreatorServiceCreateEditModal from "./CreatorServiceCreateEditModal.vue";
import CreatorServiceList from "./CreatorServiceList.vue";
import { useCreatorServices } from "../hooks/useCreatorServices";

export default defineComponent({
  name: "CreatorServiceManage",
  components: { CreatorServiceCreateEditModal, CreatorServiceList },
  props: {
    userId: { type: String, required: true },
    forceCreate: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { uploadThenUpdate } = useFiles();

    const loading = ref(false);
    const showCreate = ref(props.forceCreate);
    const serviceToEdit = ref<CreatorService | null>(null);
    const selectedFilter = ref<CreatorServiceCategory | "">("");

    const searchData = computed<InputCreatorServiceSearch>(() => ({
      userId: props.userId,
      categories: selectedFilter.value ? [selectedFilter.value] : undefined,
      sort: "ID,DESC",
    }));

    const { items, enableScroll, getFirstPage, getNextPage, create, update, remove, updateItem } = useCreatorServices(
      searchData
    );

    const onCloseCreateEdit = () => {
      if (items.value.length) {
        showCreate.value = false;
        serviceToEdit.value = null;
      } else {
        emit("close");
      }
    };

    const onUpdate = async (
      data: InputCreatorServiceUpdate | InputCreatorServiceCreate,
      preview: File | null,
      cb: () => void
    ) => {
      try {
        data.userId = props.userId;
        let service: CreatorService;
        if ("id" in data) {
          service = await update(data);
        } else {
          service = await create(data);
        }

        if (preview && service) {
          service.preview = await uploadThenUpdate({
            file: preview,
            fileId: { subjectId: service.id, type: "creator_service_preview" },
          });
          updateItem(service, i => i.id === service.id);
        }

        serviceToEdit.value = null;
        showCreate.value = false;
      } finally {
        cb();
      }
    };

    const onRemove = async (id: string, cb: () => void) => {
      try {
        await remove(id);
      } finally {
        cb();
      }
    };

    const getData = async () => {
      try {
        loading.value = true;
        await getFirstPage();
      } finally {
        loading.value = false;
      }
    };

    watch(
      selectedFilter,
      () => {
        getData();
      },
      { immediate: true }
    );

    return {
      loading,
      enableScroll,
      items,
      showCreate,
      serviceToEdit,
      selectedFilter,
      onCloseCreateEdit,
      onUpdate,
      onRemove,
      getNextPage,
    };
  },
});
